import React, { ChangeEventHandler, KeyboardEventHandler } from 'react';
import { searchSvg } from 'components/ComponentExhibitor/AllForExhibitor';

import './SearchRow.css';

interface IExhibitorStyleSearchProps {
  value: string;
  placeholder: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
  afterContent?: React.ReactNode;
  inputRef?: React.RefObject<HTMLInputElement>;
  onCompositionStart?: React.CompositionEventHandler<HTMLInputElement>;
  onCompositionEnd?: React.CompositionEventHandler<HTMLInputElement>;
}

const ExhibitorStyleSearch = ({
  value,
  placeholder,
  onChange,
  onSearch,
  afterContent,
  inputRef,
  onCompositionStart,
  onCompositionEnd,
}: IExhibitorStyleSearchProps) => {
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="exhibitor-style-search">
      <div
        className="search-icon"
        style={{
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          opacity: 0.5,
        }}
        onClick={onSearch}
      >
        {React.cloneElement(searchSvg as React.ReactElement, {
          style: {
            width: '20px',
            height: '20px',
            display: 'block',
          },
        })}
      </div>
      <input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
      />
      {afterContent ? <div className="search-after">{afterContent}</div> : null}
    </div>
  );
};

export default ExhibitorStyleSearch;